// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"daa30e85","513":"3a38ee4e","703":"b9d57c7e","787":"568305dd","875":"c4bf5191"}[chunkId] + ".chunk.js";
};